require('jquery.mmenu');
import catalogTreeModel from './includes/catalog-tree-model.js'
import catalogTreeGenerator from './includes/catalog-tree-generator.js'

async function initCatalogTree() {
  let $container = $('#side-catalog-nav');
  
  let json = await catalogTreeModel.get();
  console.log('tree catalog',json);
/*
  let tpl = require('./includes/side-catalog-nav.hbs');
  $container.append(tpl(json));
*/
  
  let generator = new catalogTreeGenerator();
  generator.render($container,json.tree);

  //setTimeout(function() {

    $container.show();
    $container.mmenu({
      offCanvas: false,
      extensions: [
        'theme-white',
        'fx-menu-slide',
        'border-full'
      ],
      autoHeight: true,
      counters: true,
      navbar: {
        'title': 'Отделы магазина'
      },
      navbars: false
    });
    
    var categoryMenu = $container.data('mmenu');
    console.log("generator",generator);
    if ((generator.curTreePanelId !== null) && (generator.catalogTreePanels[generator.curTreePanelId] !== undefined)) {
      categoryMenu.openPanel(generator.catalogTreePanels[generator.curTreePanelId]);
    }

  //}, 300);

}

$(document).ready(()=>{
  initCatalogTree();
});